/**
 * Persistencia del override `?template=` para demos/previews.
 * Sin esto, al navegar a /shop/cart se pierde el query y vuelve
 * la plantilla real del negocio.
 *
 * El override se vincula al pathId del negocio actual para evitar
 * que al visitar otro negocio en la misma sesión se arrastre un
 * template de una demo anterior.
 *
 * Si se abre la home del negocio sin `?template=` (o con el param
 * vacío), se borra el override: quitar el query de la URL vuelve
 * a la plantilla real.
 */

const STORAGE_KEY = "applaby_template_override";
const PATH_KEY = "applaby_template_override_path";

function getCurrentPathId() {
	if (typeof window === "undefined") return null;
	const segments = window.location.pathname.split("/").filter(Boolean);
	return segments[0] || null;
}

function isSiteRoot() {
	if (typeof window === "undefined") return false;
	const segments = window.location.pathname.split("/").filter(Boolean);
	return segments.length <= 1;
}

export function getTemplateOverride() {
	if (typeof window === "undefined") return null;
	const params = new URLSearchParams(window.location.search);
	const fromUrl = params.get("template");
	const pathId = getCurrentPathId();

	if (fromUrl) {
		try {
			sessionStorage.setItem(STORAGE_KEY, fromUrl);
			sessionStorage.setItem(PATH_KEY, pathId || "");
		} catch {
			/* ignore */
		}
		return fromUrl;
	}

	if (params.has("template") || isSiteRoot()) {
		clearTemplateOverride();
		return null;
	}

	try {
		const stored = sessionStorage.getItem(STORAGE_KEY);
		const storedPath = sessionStorage.getItem(PATH_KEY);
		if (stored && storedPath === (pathId || "")) return stored;
		return null;
	} catch {
		return null;
	}
}

export function clearTemplateOverride() {
	try {
		sessionStorage.removeItem(STORAGE_KEY);
		sessionStorage.removeItem(PATH_KEY);
	} catch {
		/* ignore */
	}
}

/** Añade ?template= a una ruta interna si hay override activo. */
export function withTemplateQuery(path) {
	const template = getTemplateOverride();
	if (!template || !path) return path;

	const hashIndex = path.indexOf("#");
	const hash = hashIndex >= 0 ? path.slice(hashIndex) : "";
	const withoutHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
	const qIndex = withoutHash.indexOf("?");
	const pathname = qIndex >= 0 ? withoutHash.slice(0, qIndex) : withoutHash;
	const search = qIndex >= 0 ? withoutHash.slice(qIndex + 1) : "";
	const params = new URLSearchParams(search);
	if (!params.has("template")) {
		params.set("template", template);
	}
	const query = params.toString();
	return `${pathname}${query ? `?${query}` : ""}${hash}`;
}
